import axios from "axios";

import { getBaseUrl, getRedirectUri } from "./auth-config";
import { REACT_APP_BASE_URL } from "./config";
import { setToken } from "./local-storage";

export interface AuthPostLogin {
  username: string;
  password: string;
}

const auth = {
  login: async (data: AuthPostLogin) => {
    const response = await axios.post(`${REACT_APP_BASE_URL}/benutzer/login`, {
      ...data,
    });
    setToken(response.data);
    return response;
  },
  getUserDetails: async (token: string) => {
    const response = await axios.get(`${REACT_APP_BASE_URL}/benutzer`, {
      method: "GET",
      headers: { Authorization: token },
    });
    return response;
  },
  verifyRedirect: async (token: string) => {
    const response = await axios.get(`${REACT_APP_BASE_URL}/benutzer/` + token);
    setToken(response.data);
    return response;
  },

  getAuthUrl: async () => {
    const redirectUri = getRedirectUri();
    const response = await axios.get(
      `${getBaseUrl()}/benutzer/login/auth-url?redirect_uri=${encodeURIComponent(redirectUri)}`
    );
    return response.data.url;
  },

  handleAuthCode: async (code: string) => {
    const redirectUri = getRedirectUri();
    const response = await axios.post(`${getBaseUrl()}/benutzer/login/code`, {
      code,
      redirectUri,
    });
    setToken(response.data.bearerToken);
    return response;
  },

  initiateSSO: async () => {
    try {
      const authUrl = await auth.getAuthUrl();
      window.location.href = authUrl;
    } catch (error) {
      console.error("Error initiating SSO:", error);
      throw error;
    }
  },
};

export default auth;
